<template>
  <div>
    <Logs :showForm="showLogs" :formData="formData" />

    <div>
      <p  v-if="!layout && !avulso">
        <ed-alert title="Atenção">
          <p slot="description">
            Para visualizar a documentação do eSocial favor acessar o link
            <a
              target="_blank"
              href="https://docs.google.com/document/d/e/2PACX-1vSBgbysNalUj6JJ9QpfYQGAU1w34wBgbXkN888R4b5jI1KbwgjQGRWEiMOVlbdpX4HKHAuPWE77ivY9/pub"
            >
              visualizar documentação
            </a>
          </p>
        </ed-alert>
      </p>
      <ed-form
        v-if="!avulso"
        :data="formData"
        :config="config"
        :response="response"
        :itens="layoutItems"
      >
        <div slot="form-footer"></div>
      </ed-form>


      <el-tabs type="card" v-model="tabConfig">
        <el-tab-pane label="Config" name="tab-geral">
          <span slot="label">
            <i class="fa fa-list-alt"></i> Consultar Arquivos Disponíveis
          </span>

            <ed-alert title="Atenção" v-if="!this.layout && formData.esocial_tabela && formData.esocial_tabela.descricao" type="warning" class="mb-2 mt-2">
              <p slot="description">
                {{formData.esocial_tabela.descricao}}
              </p>
            </ed-alert>

            <ed-table
              :onSearch="getEsocial"
              :onRegister="avulso ? onRegister : null"
              :onEdit="avulso ? onEditXml : null"
              :onClear="onClear"
              :onFilter="getEsocial"
              :tableHead="tableHead"
              :tableData="tableData"
              :loadingTable="config.loading.table"
              :pagination="pagination"
              :response="response"
              :filterBadge="filterBadge"
              registerName="Inserir novo XML"
            >
              <div slot="table-filter-content">
                <Filters :parent="this" />
              </div>
            </ed-table>

            <s0000
              v-if="avulso" :parent="this"
            ></s0000>
             <s2210
              v-else-if="
                !config.loading.table &&
                formData.layout &&
                formData.layout == 'S-2210'
              "
              :parent="this"
            ></s2210>
            <s2220
              v-else-if="
                !config.loading.table &&
                formData.layout &&
                formData.layout == 'S-2220'
              "
              :parent="this"
            ></s2220>
            <s2240
              v-else-if="
                !config.loading.table &&
                formData.layout &&
                formData.layout == 'S-2240'
              "
              :parent="this"
            ></s2240>
            <s3000
              v-else-if="
                !config.loading.table &&
                formData.layout &&
                formData.layout == 'S-3000'
              "
              :parent="this"
            ></s3000>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EdTable from "common/table";
import EdForm from "common/form";
import Rest from "common/rest";
import { EdAlert } from "template";
import FormItems from "./_form/layout";
import Logs from "./includes/logs";
import Filters from "./includes/filter";

//layouts
import s0000 from "./s0000";
import s2210 from "./s2210";
import s2220 from "./s2220";
import s2240 from "./s2240";
import s3000 from "./s3000";

export default {
  name: "esocial",
  mixins: [Rest],
  components: {
    EdTable,
    EdForm,
    Filters,
    Logs,
    s0000,
    s2220,
    s2210,
    s2240,
    s3000,
    EdAlert,
  },
  watch: {
    "formData.esocial_tabela"() {
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:this.avulso,
        data_cadastro: [],
        mostrar: [],
      };
      this.formData.layout = this.formData.esocial_tabela.codigo
      this.getEsocial();
    },
    "layout"() {
      this.formData.layout = this.layout
    },
    "lote"() {
      this.getEsocial()
    },
  },
  props: {
    layout: {
      type: String,
      default: function () {
        return null;
      },
    },
    lote: {
      type: [String,Number],
      default: function () {
        return null;
      },
    },
    avulso: {
      type: [Number],
      default: function () {
        return 0;
      },
    },
  },
  data() {
    return {
      tabConfig:'tab-geral',
      config: {
        click: {
          esocial_tabela: this.getEsocialTabela,
        },
        loading: {
          esocial_tabela: false,
          content: false,
          table: false,
          tableAntigo: false,
        },
        list: {
          esocial_tabela: [],
        },
        hidden:{
          esocial_tabela:(this.layout ? true : false)
        }
      },
      formData: {
        layout: null,
        esocial_tabela:null,
        item: null,
        search: null,
        page: null,
        pagination: null,
        filter: null,
        empresa: null,
        arquivoConfig: {},
        result: {},
      },
      formDataXml:{

      },
      layoutItems: [],
      formFilter: {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:1,
        data_cadastro: [],
        mostrar: [],
      },
      pagination: {},
      response: {},
      filterBadge: 0,
      showLogAntigo:false,
      showNovoXml:false,
      paginationAntigo: {},
      responseAntigo: {},
      filterBadgeAntigo: 0,
      tableHead: [],
      tableData: [],
      tableHeadAntigo: [],
      tableDataAntigo: [],
      showLogs: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.layoutItems = FormItems;
    this.getEsocialTabela();

    //if(this.avulso){
      this.getEsocial()
    //}
    
  },

  methods: {

    onClear(){
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status:[]
      },

      this.getEsocial()
    },

    onRegister(){
      this.formDataXml = {}
      this.showNovoXml = !this.showNovoXml
    },

    onEditXml(data) {
      this.showNovoXml = !this.showNovoXml
      this.formDataXml = Object.assign(data,{})
    },


    onEdit(data) {
      this.onGerarArquivoXML([data.id],data.layout);
    },

    onDelete(data) {

      let arrayExcluir = []
      let avulso = false

      if(data && data.id){
        arrayExcluir.push(data.id)

        if(data.avulso == '1' && [328].indexOf(data.tipo_status.id) != -1){
          avulso = true
        }
      }

      if(!arrayExcluir.length){
         this.edAlert(
          "Arquivo indispoível para exclusão.","error"
        );
        return;
      }

      let msg = "O sistema vai excluir "+arrayExcluir.length+" arquivo(s) diretamente no eSocial e o processo não poderá ser desfeito. Deseja prosseguir?"

      if(!data.recibo){
        msg = "O sistema vai excluir "+arrayExcluir.length+" arquivo(s) e o processo não poderá ser desfeito. Deseja prosseguir?"
      }

      this.$confirm(msg,
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.$root.$loading.set(true);
        this.config.loading.content = true;

        var filter = {
          ids: [data.id],
        };

        var empresa_id = null;

        this.post(
          "esocial/" + this.formData.layout+"/deletar",
          { ids: arrayExcluir }
        ).then((result) => {
          result = result[0];
          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {

            if(avulso){
              this.edAlert(
              "Evento excluído com sucesso."
            );
            }
            else{
              this.edAlert(
              "Evento de exclusão enviado para o eSocial."
            );
            }
            
          }
        });
      });
    },

    onGerarLote(data) {
      this.$confirm(
        "O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.content = true;
        this.$root.$loading.set(true);

        var filter = {
          ids: [data.id],
          avulso:this.avulso
        };

        var empresa_id = null;

        if (data.empresa) {
          empresa_id = data.empresa.id;
        } else if (data.ghe && data.ghe.ltcat) {
          empresa_id = data.ghe.ltcat.empresa.id;
        }

        this.get(
          "esocial/lotes/gerar/" + data.layout + "/" + empresa_id,
          { filter: filter }
        ).then((result) => {
          result = result[0];
          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {
            this.edAlert(
              "Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo."
            );
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },

    onGerarArquivoXML(ids,layout = null) {
      this.$confirm(
        "Tem certeza que deseja gerar o xml dos registro(s) selecionados?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.content = true;
        this.$root.$loading.set(true);

        var filter = {
          ids: [ids],
          avulso:this.avulso
        };

        this.get("esocial/" + (layout ? layout : this.formData.layout) + "/gerar-arquivo-xml", {
          filter: filter,
        }).then((result) => {
          result = result[0];

          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {
            this.edMsg("Operação realizada com sucesso");
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },

    onDownloadXML(data) {
      if (data.xml) {
        var contents = data.xml;
        var filename = data.uid + ".xml";
        var contentType = "application/xml";

        var blob = this.b64toBlob(contents, contentType);

        this.download(blob, filename);
      }
    },

    onLogs(data) {
      this.formData.item = data;
      this.showLogs = !this.showLogs;
    },

    getEsocialTabela(_search, _page, _pagination) {
      
      this.config.loading.esocial_tabela = true;
      this.config.list.esocial_tabela = [];

      this.get("esocial/tabelas/conteudo/9", {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];

        this.config.loading.esocial_tabela = false;

        if (result.status == 200) {
          this.config.list.esocial_tabela = result.data.data;

          if (this.config.list.esocial_tabela.length && !this.formData.esocial_tabela) {
            this.formData.esocial_tabela = this.config.list.esocial_tabela[0];
            this.formData.layout = this.config.list.esocial_tabela[0].codigo;
          }
        }
      });
    },

    getEsocial (_search, _page, _pagination) {

      this.$root.$loading.set(true);

      this.filterBadge =
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.id_fdt ? 1 : 0) +
        (this.formFilter.id_funcionario ? 1 : 0) +
        (this.formFilter.empresa_envio_automatico ? 1 : 0) +
        (this.formFilter.data_cadastro &&
        this.formFilter.data_cadastro[0] &&
        this.formFilter.data_cadastro[1]
          ? 1
          : 0) +
        (this.formFilter.mostrar && this.formFilter.mostrar.length > 0 ? 1 : 0);

        if(this.lote){
        this.formFilter['lote'] = this.lote
      }

      this.formData.search = _search;
      this.formData.page = _page;
      this.formData.pagination = _pagination;

      this.config.loading.table = true;
      this.response = {};
      this.pagination = {};

      this.config.loading.tableAntigo = true;
      this.responseAntigo = {};
      this.paginationAntigo = {};

      if(this.layout){
        this.formData.layout = this.layout
      }

      let url = "esocial/" + this.formData.layout
      if(this.avulso){
        url = "esocial/avulso"
      }

      this.get(url, {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.config.loading.table = false;
        this.$root.$loading.set(false);

        if (result.status == 200) {
          this.pagination = result;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?7fdcd7b0